import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {  ErrorMessage, useFormik, FormikProvider, Field, } from "formik";
import { Form, FormGroup, FormLabel, Col, Container, Nav, Navbar, Row, NavDropdown, Button } from "react-bootstrap";
import * as DESUI from "react-bootstrap";

import * as Yup from "yup";
import { useNavigate } from "react-router";
import DesService from "../Services/Des Service";
import { FiPower } from "react-icons/fi";
import ShowAlert from "./alert";
import { BiSolidUserCircle } from "react-icons/bi";
import { FaEye, FaEyeSlash, FaUser } from "react-icons/fa";
import Swal from "sweetalert2";

const ChangePassword = () => {

    const token = localStorage.getItem("token");

  const navigate = useNavigate();
  const [update,setUpdate]=useState(false)
  const [otpenb,setOtpenb]=useState(true)
  const[maskedNum,setMasked]=useState()
  const[click,setClick]=useState()
  const password_updated_days =localStorage.getItem("password_updated_days");
  const Isvaliduser =localStorage.getItem("Isvaliduser");

 const Logout=()=>{
  let params1={
    token:localStorage.getItem("token")
}
  DesService.userLogout(params1).then(() => {
    navigate("/Login");
    localStorage.removeItem("token");
    localStorage.removeItem("serviceList");
    localStorage.clear();
  })
 }
useEffect(() => {
  const phoneNumber = localStorage.getItem("phone");
  if (phoneNumber && phoneNumber.length > 0) {
    const maskedPhoneNumber = phoneNumber.slice(0, -4).replace(/./g, '*') + phoneNumber.slice(-4);
    setMasked(maskedPhoneNumber);
  } else {
    console.error("Invalid phone number.");
  }

}, []); 
  const validationSchema = Yup.object().shape({
    oldpassword: Yup.string().required("Required"),
    newPassword: Yup.string().min(8, "Password must be at least 8 characters long").matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Password must contain at least one number, one special character, and one uppercase letter.").required("Required*"),
    confirmpassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match').required('Please confirm your password'),
   
  });
  const formik = useFormik({
    initialValues: {
      userid: "",
      oldpassword: "",
      newPassword: "",
      confirmpassword: "",
      otp:""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let params = {
        userid: localStorage.getItem("username"),
        oldpassword: values.oldpassword,
        newpassword: values.newPassword,
        confirmpassword: values.confirmpassword
      };
      DesService.changepassword(params).then((res) => {
        if (res?.data?.SCODE === "01") {
          ShowAlert(res?.data?.SDESC, "success").then(() => {
          Logout()
          })
        } else {
          ShowAlert(res?.data?.SDESC, "warning");

        }

      });
    },
  });

const [showNewPassword, setShowNewPassword] = useState(false);
const [showcnfPassword, setshowcnfPassword] = useState(false);
const [showoldPassword, setshowoldPassword] = useState(false);

  function handleLogOut() {
     let params = {
       token: token,
     };
     Swal.fire({
       text: "Are You Sure Want to Log Out?",
       icon: "question",
       showCancelButton: true,
       confirmButtonColor: "#3085d6",
       cancelButtonColor: "#d33",
       confirmButtonText: "Yes",
     }).then((result) => {
       localStorage.removeItem("username");
       if (result.isConfirmed) {
         navigate("/Logout.do");
       }
     });
   }
  

  return (
    <>
     
 
  <div style={{ position: "sticky", top: 0, zIndex: 1050, background: "#fff" }}>
          {/* Header */}
          <div className="main-header">
            <div className="header-logo-area">
              <div className="header-logo">
                <img src="../images/aplogo.webp" alt="APlogo" style={{ width:"70px",height:"auto" }} />
              </div>
              <div className="header-title">
                <h1>Directorate of Economics &amp; Statistics</h1>
                <p>Government of Andhra Pradesh</p>
              </div>
            </div>
            <div className="header-right">
   
              <NavDropdown
                align="end"
                id="user-dropdown"
                title={
                  <div className="user-box">
                    <div className="user-avatar">
                      <FaUser style={{ fontSize: 18, color: "#fff" }} />
                    </div>

                    <div className="user-info">
                      <div className="user-name">{localStorage.getItem("displayName")}</div>

                      <div className="user-last-login">Last login: {localStorage.getItem("lastlogintime")}</div>
                    </div>
                  </div>
                }
              >
                <NavDropdown.Item onClick={handleLogOut}>Logout</NavDropdown.Item>
              </NavDropdown>
            </div>
          </div>
          </div>

 

      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>

          <Container  className='map-header4'>
            <div className='sa-title'>
              <h2>Change <span>Password</span></h2>
            </div>
          </Container>


          <Container className="outer-page-content-container1 mainpage-container "  style={{ width: "50%" }} >
            <Container className="change-container">
            <div className="justify-content-center" >
     

      <Row className="p-3 justify-content-center" >
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Old Password </h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                     <div className="position-relative">
                    <Field type={showoldPassword ? "text" : "password"} name="oldpassword" maxLength={20} placeholder="Old password" className="form-control sample" onChange={(e)=>{formik.setFieldValue('oldpassword',e.target.value)}} />
<span onClick={() => setshowoldPassword(!showoldPassword)} style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#6c757d", }} > {showoldPassword ? <FaEye />:<FaEyeSlash />} </span>
                    </div>
                    <ErrorMessage name="oldpassword" className="text-error" component="div" />


                  </FormGroup>
                </Col>
              </Row>
         <Row className="p-3 justify-content-center" >
               <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
  <FormGroup as={Col}>
    <FormLabel>
      <h6 style={{ color: "var(--dark-gray)", fontWeight: "bold" }}>
        New Password
      </h6>
    </FormLabel>
    <span className="mandatory" style={{ color: "red" }}> *</span>

    <div className="position-relative">
      <Field
        type={showNewPassword ? "text" : "password"}
        name="newPassword"
        maxLength={20}
        placeholder="New Password"
        className="form-control sample pe-5"
        onChange={(e) =>
          formik.setFieldValue("newPassword", e.target.value)
        }
      />

      <span onClick={() => setShowNewPassword(!showNewPassword)} style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#6c757d", }} > {showNewPassword ?  <FaEye />:<FaEyeSlash /> } </span>
    </div>

    <ErrorMessage
      name="newPassword"
      className="text-error"
      component="div"
    />
  </FormGroup>
</Col>
              </Row>
              <Row className="p-3 justify-content-center" >
              <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <FormGroup as={Col}>
                    <FormLabel> <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Confirm Password </h6> </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <div className="position-relative">
                    <Field type={showcnfPassword ? "text" : "password"} name="confirmpassword" maxLength={20} placeholder="confirm password" className="form-control sample" onChange={(e)=>{formik.setFieldValue('confirmpassword',e.target.value)}}/>
<span onClick={() => setshowcnfPassword(!showcnfPassword)} style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#6c757d", }} > {showcnfPassword ? <FaEye />:<FaEyeSlash />} </span>
</div>
                    <ErrorMessage name="confirmpassword" className="text-error" component="div" />

                  </FormGroup>
                </Col>
                </Row>
             
              <Row className="p-3 justify-content-center">
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="d-flex justify-content-end" >
                  <div class="d-grid  mt-9  "> <button type="submit" className="btn btn-success btn-sm" > Submit </button> </div>
                </Col>
              </Row>
            </div>
            </Container>
           
          </Container>
        </Form>
      </FormikProvider>
    </>
  );
};
export default ChangePassword;
